import getConfig from 'next/config';

const { webPath } = getConfig().publicRuntimeConfig;

export const checkLinkToSravniContent = (link: string): boolean => {
  try {
    const url = new URL(link);

    const isSravniLink = url.origin === webPath;
    const isContentLink = /^\/(info|text|novost|q|mag|promo)(\/|$)/g.test(url.pathname);
    const isLinkToSravniContent = isSravniLink && isContentLink;

    return isLinkToSravniContent;
  } catch (e) {
    return false;
  }
};
